import { render, staticRenderFns } from "./BaseVideoBanner.vue?vue&type=template&id=5172a0fa&"
import script from "./BaseVideoBanner.vue?vue&type=script&lang=js&"
export * from "./BaseVideoBanner.vue?vue&type=script&lang=js&"
import style0 from "./BaseVideoBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports